import {
	alias,
	date,
	deserialize,
	identifier,
	object,
	serializable,
} from "serializr";
import { IJsonObject } from "../api";
import { User } from "../users";

interface IProps {
	id?: number | null;
	userId?: number | null;
	taskId?: number | null;
	user?: User | null;
	oldValue?: string;
	newValue?: string;
	createdAt?: Date;
	action?: string;
}

export enum ProjectTaskActionType {
	Created = "created",
	ChangedName = "changed_name",
	AddedMember = "added_member",
	RemovedMember = "removed_member",
	ChangedStatus = "changed_status",
	LoggedTime = "logged_time",
}

export class ProjectTaskAction {
	public static fromJson(json: IJsonObject): ProjectTaskAction {
		return deserialize(ProjectTaskAction, json);
	}

	public static fromJsonArray(json: IJsonObject[]): ProjectTaskAction[] {
		return json.map((task: IJsonObject) => this.fromJson(task));
	}

	@serializable(identifier())
	public id: number | null;

	@serializable(alias("user_id"))
	public userId: number | null;

	@serializable(alias("task_id"))
	public taskId: number | null;

	@serializable(alias("old_value"))
	public oldValue: string;

	@serializable(alias("new_value"))
	public newValue: string;

	@serializable
	public action: string;

	@serializable(alias("created_at", date()))
	public createdAt: Date;

	@serializable(object(User))
	public user: User | null;

	constructor({
		id = null,
		userId = null,
		taskId = null,
		user = null,
		oldValue = "",
		newValue = "",
		action = "",
		createdAt = new Date(),
	}: IProps = {}) {
		this.id = id;
		this.userId = userId;
		this.taskId = taskId;
		this.user = user;
		this.oldValue = oldValue;
		this.newValue = newValue;
		this.createdAt = createdAt;
		this.action = action;
	}

	public getReadableMessage() {
		let message = "";
		if (this.action === ProjectTaskActionType.Created) {
			message = `Added this card to ${this.newValue} `;
		}

		if (this.action === ProjectTaskActionType.ChangedName) {
			message = `Change the name from ${this.oldValue} to ${
				this.newValue
			}`;
		}

		if (this.action === ProjectTaskActionType.ChangedStatus) {
			message = `Moved the card from ${this.oldValue} to ${
				this.newValue
			}`;
		}

		if (this.action === ProjectTaskActionType.RemovedMember) {
			message = `Removed member ${this.newValue}`;
		}

		if (this.action === ProjectTaskActionType.AddedMember) {
			message = `Added member ${this.newValue}`;
		}

		if (this.action === ProjectTaskActionType.LoggedTime) {
			message = `Logged ${this.newValue} hours`;
		}

		return message;
	}
}
